import withReducer from '../../store/withReducer'
import Inventory from './container'
import reducer from './module'

export default withReducer('inventory', reducer)(Inventory)



// WEBPACK FOOTER //
// ./src/legacy/pages/Inventory/index.js